import React, { useMemo } from "react";
import { Route } from "react-router-dom";
import PropTypes from "prop-types";
import { withOidcSecure } from "@axa-fr/react-oidc-context";
import useUserData from "hooks/useUserData";
import * as R from "ramda";
import { emptyArray } from "constants/defaultValues";
import { Forbidden } from "@totalsoft/rocket-webapp-components-deprecated";
import { useTranslation } from "react-i18next";

function ForbiddenComponent() {
  const { t } = useTranslation();
  return <Forbidden forbiddenText={t("General.InvalidRights")} />;
}

function PrivateRoute({ component: Component, exact, path, routeRights }) {
  const { rights } = useUserData();
  const SecuredComponent = useMemo(() => withOidcSecure(Component), [Component]);
  const allow = R.isEmpty(routeRights) || R.intersection(routeRights, rights || emptyArray)?.length > 0;
  const loading = !rights;

  const routeComponent = useMemo(
    () => <Route exact={exact} path={path} component={allow ? SecuredComponent : ForbiddenComponent} />,
    [SecuredComponent, exact, path, allow]
  );

  return loading ? <></> : routeComponent;
}

PrivateRoute.defaultProps = {
  routeRights: emptyArray,
};

PrivateRoute.propTypes = {
  component: PropTypes.func,
  routeRights: PropTypes.array.isRequired,
  exact: PropTypes.bool,
  path: PropTypes.string,
};

export default PrivateRoute;
